import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import { setEventPriority } from "@/lib/eventsApi";
import { eventDetailQueryKey } from "@/hooks/useEventQuery";

/**
 * Mutation that updates a single event's priority and invalidates all relevant
 * caches (event detail + event list). Used by EventsTable and
 * CalendarEventDetailSheet so the logic lives in one place.
 */
export function useSetEventPriority() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: ({ id, priority }: { id: string; priority: number }) =>
      setEventPriority(id, priority),
    onSuccess: (_data, { id }) => {
      void qc.invalidateQueries({ queryKey: ["events"] });
      void qc.invalidateQueries({ queryKey: eventDetailQueryKey(id) });
    },
    onError: () => {
      toast.error("Errore nell'aggiornamento della priorità");
    },
  });
}
